import axiosInstance from "./_authHttp";
import config from "utils/apiEndPoint";
import {
  buildUserFromAdminEmployeeProfile,
  getProfileApiErrorMessage,
} from "utils/adminEmployeeProfileAccess";

let profileRequestPromise = null;

export function normalizeAdminEmployeeProfile(responseData) {
  if (!responseData || typeof responseData !== "object") {
    return null;
  }
  if (responseData.data !== undefined && typeof responseData.data === "object") {
    return responseData.data;
  }
  return responseData;
}

export async function fetchAdminEmployeeProfile() {
  if (profileRequestPromise) {
    return profileRequestPromise;
  }

  profileRequestPromise = axiosInstance
    .get(config.profile.info)
    .then((response) => {
      const profile = normalizeAdminEmployeeProfile(response?.data);
      if (!profile) {
        throw new Error("Invalid profile response from server.");
      }
      return profile;
    })
    .finally(() => {
      profileRequestPromise = null;
    });

  return profileRequestPromise;
}

/** Load profile + normalized permissions for session (login / app boot) */
export async function loadAdminEmployeeSession(currentUser = {}) {
  try {
    const profile = await fetchAdminEmployeeProfile();
    return {
      ok: true,
      profile,
      user: buildUserFromAdminEmployeeProfile(profile, currentUser),
    };
  } catch (error) {
    return {
      ok: false,
      error,
      message: getProfileApiErrorMessage(error),
      user: {
        ...currentUser,
        is_admin_employee: true,
        user_type: "admin_employee",
        permissions: currentUser.permissions || [],
        profile_loaded: false,
        profile_error: getProfileApiErrorMessage(error),
      },
    };
  }
}
